// src/components/molecules/MultiSelectFilter/MultiSelectFilter.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem, Checkbox, ListItemText, Box } from '@mui/material';
import { operationalScrollbars } from '../../../design-system/tokens';

/**
 * MultiSelectFilter - Componente molecular para filtro multi-seleção
 *
 * Este componente permite selecionar múltiplas opções em um filtro.
 * Segue o princípio do Atomic Design como uma "molécula".
 *
 * Suporta ícones opcionais para cada opção.
 */
const MultiSelectFilter = ({
  value,
  onChange,
  options = [],
  label = 'Selecionar',
  className = '',
  size = 'small',
  ...props
}) => {
  return (
    <FormControl size={size} className={`multi-select-filter ${className}`} sx={{ minWidth: 140 }} {...props}>
      <Select
        displayEmpty
        multiple
        value={value || []}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selected) => {
          if (selected.length === 0) return label;
          if (selected.length === 1) {
            const option = options.find(opt => opt.value === selected[0]);
            return option ? option.label : label;
          }
          return `${label} (${selected.length})`;
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              ...operationalScrollbars.default,
            },
          },
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={(value || []).indexOf(option.value) > -1} />
            {option.icon ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {option.icon}
                <ListItemText primary={option.label} />
              </Box>
            ) : (
              <ListItemText primary={option.label} />
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MultiSelectFilter.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium'])
};

export default MultiSelectFilter;
